import type { Middleware } from 'openapi-fetch';
import { handleAuthErrorResponse } from './auth-error-response';
import { HTTP_STATUS } from './http-status';

/** 401/403 を共通ハンドラに委譲する openapi-fetch ミドルウェア */
export const createAuthMiddleware = (): Middleware => ({
  async onResponse({
    response
  }) {
    if (response.status === HTTP_STATUS.UNAUTHORIZED || response.status === HTTP_STATUS.FORBIDDEN) {
      await handleAuthErrorResponse(response);
    }
    return response;
  }
});